import React from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Container,
    Grid2
} from '@mui/material';
import { Description, FolderZip } from '@mui/icons-material';

const NewPill = () => (
    <Box
        component="span"
        sx={{
            px: 0.75,
            py: 0.15,
            borderRadius: 999,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            color: 'text.secondary',
            fontSize: '0.62rem',
            fontWeight: 700,
            letterSpacing: '0.08em',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
        }}
    >
        NEW
    </Box>
);

export default function Supplementary() {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" component="h2" sx={{ fontWeight: 600, mb: 2 }}>
                    Downloads
                </Typography>
                <Grid2 container spacing={2}>
                    <Grid2 item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: '100%',
                            }}
                        >
                            <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                <Box
                                    component="a"
                                    href="/vis-badges-suppl-material.zip"
                                    download
                                    sx={{ display: 'flex', alignItems: 'center', gap: 2, textDecoration: 'none', color: 'inherit' }}
                                >
                                    <FolderZip sx={{ fontSize: 24, color: 'primary.main' }} />
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                                            Download Visualization Badges supplementary materials
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            ZIP format
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box
                                    component="a"
                                    href="/visualization-badges.pdf"
                                    download
                                    sx={{ display: 'flex', alignItems: 'center', gap: 2, textDecoration: 'none', color: 'inherit' }}
                                >
                                    <Description sx={{ fontSize: 24, color: 'primary.main' }} />
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            Download Visualization Badges paper
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            PDF format
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: '100%',
                            }}
                        >
                            <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                <Box
                                    component="a"
                                    href="/mind-the-badge-supplementary-material.zip"
                                    download
                                    sx={{ display: 'flex', alignItems: 'center', gap: 2, textDecoration: 'none', color: 'inherit' }}
                                >
                                    <FolderZip sx={{ fontSize: 24, color: 'primary.main' }} />
                                    <Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                Download Mind the Badge supplementary materials
                                            </Typography>
                                            <NewPill />
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                            ZIP format
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: 'text.disabled' }}>
                                    <Description sx={{ fontSize: 24, color: 'text.disabled' }} />
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            Mind the Badge paper
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid2>
                </Grid2>
            </Box>
        </Container>
    );
}
